import Client from './KomodoClient';

// komodo's generic REST convention (Komodo.Blazor.Shared/Data/RestfulDataService.cs):
//   GET  /api/{res}                 list all
//   POST /api/{res}/query-pager     paged query, body = PageQuery + resource filters
//   POST /api/{res}/query-list      unpaged query
//   GET  /api/{res}/parent-list/{p} children of a parent code
//   GET  /api/{res}/{id}            one row
//   POST /api/{res}                 create (the primary key is generated server-side)
//   PUT  /api/{res}/{id}            update (full DTO)
//   DELETE /api/{res}/{id}          delete (soft for some resources: StopFlag = true)
// Paged responses are PagerRecord { recordList, itemCount, currentPage }.

// Settings lists are small; like Blazor's "load everything then filter locally" pages we ask for one big page.
export const PAGE_ALL = { pageIndex: 1, pageItems: 10000, isPage: true };

const enc = (v) =>
	encodeURIComponent(v === undefined || v === null ? '' : String(v));

export const pagerRows = (data) => {
	if (Array.isArray(data)) return data;
	if (data && Array.isArray(data.recordList)) return data.recordList;
	return [];
};

// komodo SetArchived replies CommonActionResult inside a success envelope: a refusal (a warehouse in
// use, a missing row) is { isSuccessful: false, message } and must surface as an error.
export const archiveResult = (result) => {
	if (result && result.isSuccessful === false)
		throw new Error(result.message || 'Archive failed');
	return result;
};

const resourceApi = (resName) => {
	const base = `/api/${resName}`;
	return {
		resName,
		list: (params) => Client.get(base, params),
		queryList: (query) => Client.post(`${base}/query-list`, query || {}),
		queryPager: (query) =>
			Client.post(`${base}/query-pager`, {
				...PAGE_ALL,
				...(query || {}),
			}).then(pagerRows),
		parentList: (parentCode) =>
			Client.get(`${base}/parent-list/${enc(parentCode)}`),
		getById: (id, params) => Client.get(`${base}/${enc(id)}`, params),
		// GET /api/{res}/tree (departments)
		tree: () => Client.get(`${base}/tree`),
		create: (dto) => Client.post(base, dto),
		update: (id, dto) => Client.put(`${base}/${enc(id)}`, dto),
		remove: (id) => Client.del(`${base}/${enc(id)}`),
		// PUT /api/{res}/archive/{id} { archived }: komodo changes StopFlag only through this action.
		archive: (id, archived) =>
			Client.put(`${base}/archive/${enc(id)}`, { archived: !!archived }).then(
				archiveResult
			),
	};
};

export default resourceApi;
